"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readableComponentListFromAsset = readableComponentListFromAsset;
function readableComponentListFromAsset(asset) {
    return {
        accessors: asset.accessors,
        asset: asset,
        attributes: asset.attributes,
        buffers: asset.buffers,
        bufferViews: asset.bufferViews,
        chunks: asset.chunks,
        items: asset.items,
        nodes: asset.nodes,
        typeHints: asset.typeHints,
        fileInfo: asset.fileInfo,
    };
}
//# sourceMappingURL=ISdtfReadableComponentList.js.map